import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from '../../../utilities/TableUtil';
import { normalColumn, dateColumn, actionEditColumn } from '../../../components/DataTable/DataTable.js';
import * as bodyStyle from '../../../components/DataTable/ConsBodyStyle.js';
// import { InputText } from 'primereact/inputtext';


export default function P411List({ dataTable, searchData, setSearchData, setAction, setData }) {

    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    // const [globalFilter, setGlobalFilter] = useState(null);

    const actionTab = (data) => {
        setSearchData({
            ...searchData,
            contractorCode: data ? data.contractorCode : ''

        })

        setAction({
            action: data ? 'แก้ไข' : 'บันทึก',
            tab: 2,
        })

        setData({})
    };

    const headerLabel = <span className="hidden-responsive">เพิ่มรายการใหม่</span>;
    const header = (
        <div className="table-header">
            <Button
                className="p-button p-button-success btn-hidden-responsive"
                label={headerLabel}
                icon="pi pi-plus"
                onClick={() => actionTab()}
                autoFocus
            />
            {/* <span className="p-input-icon-left span-responsive" >
                <i className="pi pi-search" />
                <InputText type="search" placeholder="คำค้น" 
                className="btn-responsive"
                onInput={(e) => setGlobalFilter(e.target.value)}
                />
            </span> */}
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            {/* <div className="card"> */}
            <DataTable
                value={dataTable}
                dataKey="id"
                paginator
                first={pageConf.first}
                rows={pageConf.rows}
                onPage={(e) => onPageChange(e, setPageConf)}
                rowsPerPageOptions={rowsPerPageOptions()}
                paginatorTemplate={paginatorTemplate()}
                currentPageReportTemplate={currentPageReportTemplate()}
                header={header}
                // globalFilter={globalFilter}
                emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                selectionMode="single"
            >
                <Column field="contractorSeq" header="ลำดับที่" body={(e) => normalColumn(e, 'contractorSeq', 'ลำดับ')} style={{ textAlign: 'center', width: '10%' }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column sortable field="contractorName" header="ชื่อบริษัทคู่สัญญา" body={(e) => normalColumn(e, 'contractorName', 'ชื่อบริษัทคู่สัญญา')} style={{ textAlign: 'center' }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column sortable field="contractorCode" header="รหัสบริษัทคู่สัญญา" body={(e) => normalColumn(e, 'contractorCode', 'รหัสบริษัทคู่สัญญา')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column sortable field="updateUserName" header="ผู้บันทึกแก้ไข" body={(e) => normalColumn(e, 'updateUserName', 'ผู้บันทึกแก้ไข')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column sortable field="updateDt" header="วันที่-เวลาที่แก้ไข" body={(e) => dateColumn(e, true, 'updateDt', 'วันที่แก้ไข')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                <Column header="แก้ไข" body={(e) => actionEditColumn(e, actionTab)} style={{ textAlign: 'center', width: '10%' }} bodyStyle={bodyStyle.TXT_CENTER} ></Column>

            </DataTable>
            {/* </div> */}
        </div>
    )
}


